import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from './components/LeftMenu';

const AboutUs = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('aboutUs'),
      url: '/about-us/about-us',
    },
    {
      label: 'iyiMakina.com Hakkında',
      url: '/about-us/about-us',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="iyiMakina" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">iyiMakina.com Hakkında</h1>
              </div>
            </div>
            <div className="row">
              <div className="col-15">
                <div className="media-container media-container--no-radius mb-30" style={{ backgroundImage: 'url(/temp/kepce-image.jpg)' }}>
                  <div className="video-overlay video-overlay--bg-gray">
                    <i className="video-overlay__icon fa-solid fa-play-circle" />
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Nulla vitae elit libero, a pharetra augue. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed posuere consectetur est at lobortis. Cras mattis consectetur purus sit amet fermentum.
                </p>
                <p>
                  Aenean lacinia bibendum nulla sed consectetur. Maecenas sed diam eget risus varius blandit sit amet non magna.
                  Cras mattis consectetur purus sit amet fermentum. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.
                  Cras justo odio, dapibus ac facilisis in, egestas eget quam. Curabitur blandit tempus porttitor. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.
                </p>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <div className="row mb-3">
                  <div className="col">
                    <p>
                      Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
                      Etiam porta sem malesuada magna mollis euismod. Vestibulum id ligula porta felis euismod semper. Donec ullamcorper nulla non metus auctor fringilla.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                    </p>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Curabitur convallis lobortis eros, nec viverra est ornare vel. In sit amet sapien eu enim bibendum posuere.
                      Sed cursus enim eget massa auctor posuere.
                      Fusce dictum ipsum in dapibus pellentesque.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

AboutUs.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async ({ req }) => {
  const { t } = req;

  return {
    props: {
      blackHeader: true,
      headTitle: t('aboutUs'),
    },
  };
};

AboutUs.Layout = Layout;

export default withTranslation('common')(AboutUs);
